import React from "react";

const Avatar = ({ name = "", image, size = 50 }) => {
  // Extract initials (first + last)
  const getInitials = (fullName) => {
    if (!fullName) return "";

    const parts = fullName.trim().split(" ");

    if (parts.length === 1) {
      return parts[0].charAt(0).toUpperCase(); // Single name
    }

    const first = parts[0].charAt(0).toUpperCase();
    const last = parts[parts.length - 1].charAt(0).toUpperCase();

    return first + last;
  };

  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: "50%",
        backgroundColor: "#4a90e2",
        color: "#fff",
        fontWeight: "bold",
        fontSize: size / 2.5,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
        textTransform: "uppercase",
      }}
    >
      {image ? (
        <img
          src={image}
          alt={name}
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
          onError={(e) => { e.target.style.display = "none"; }} // fallback if image fails
        />
      ) : (
        getInitials(name)
      )}
    </div>
  );
};

export default Avatar;
